<template>
  <div>
    <notifications-desktop v-if="screenType === 'desktop'"></notifications-desktop>
    <notifications-mobile v-else></notifications-mobile>
  </div>
</template>

<script>
import NotificationsDesktop from "@/components/Pages/Desktop/Dashboard/Notifications/NotificationsDesktop";
import NotificationsMobile from "@/components/Pages/Mobile/Dashboard/Notifications/NotificationsMobile";

export default {
  name: "NotificationsMain",
  components: {NotificationsMobile, NotificationsDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>